import React from "react";

const plans = [
  {
    name: "IBH Starter Pack",
    tagline: "Affordable Business Support for Every Entrepreneur",
    subTagline: "For less than ₹17/day",
    price: "₹499",
    cycle: "/month",
    highlight: false,
    cta: "Get started",
    link: "https://forms.gle/zJvy9kKRQBC8uAAR7",
    sections: [
      {
        icon: "fa-users",
        label: "Community & Networking",
        features: [],
      },
      {
        icon: "fa-newspaper",
        label: "Business Updates",
        features: [],
      },
      {
        icon: "fa-graduation-cap",
        label: "Learning Access",
        features: [],
      },
      {
        icon: "fa-file-lines",
        label: "Templates & Resources",
        features: [],
      },
      {
        icon: "fa-tag",
        label: "Member Discounts",
        features: [],
      },
    ],
  },
  {
    name: "IBH Growth Pack",
    tagline: "Serious growth support for ambitious businesses",
    subTagline: "For less than ₹34/day",
    price: "₹999",
    cycle: "/month",
    highlight: true,
    cta: "Get started",
    link: "https://forms.gle/zJvy9kKRQBC8uAAR7",
    everythingIn: "Everything in IBH Starter Pack, plus:",
    sections: [
      {
        icon: "fa-crown",
        label: "Premium Networking",
        features: [],
      },
      {
        icon: "fa-headset",
        label: "Monthly Expert Consultation",
        features: [],
      },
      {
        icon: "fa-bolt",
        label: "Priority Support",
        features: [],
      },
      {
        icon: "fa-eye",
        label: "Enhanced Visibility",
        features: [],
      },
      {
        icon: "fa-chart-line",
        label: "Funding & Growth Support",
        features: [],
      },
      {
        icon: "fa-ticket",
        label: "Event Benefits",
        features: [],
      },
    ],
  },
];

const Pricing = () => {
  return (
    <section
      id="membership"
      className="py-20 sm:py-28 relative"
      data-testid="pricing-section"
    >
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-ibh-bg via-white to-ibh-bg"></div>

      <div className="section">
        <div className="text-center max-w-2xl mx-auto">
          <span className="chip mx-auto">
            <i className="fa-solid fa-id-card text-ibh-orange"></i>
            Membership Plans
          </span>
          <h2 className="mt-4 font-display text-3xl sm:text-5xl font-bold text-slate-900 leading-tight">
            Plans that <span className="gradient-text">grow with you</span>
          </h2>
          <p className="mt-4 text-slate-600">
            Cancel anytime. Upgrade as you scale. All plans include access to
            India's most active founder community.
          </p>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6 items-start max-w-4xl mx-auto">
          {plans.map((p) => (
            <div
              key={p.name}
              data-testid={`pricing-card-${p.name}`}
              style={
  p.highlight
    ? { backgroundColor: "#0d1117", borderColor: "#0d1117", borderWidth: "2px" }
    : { backgroundColor: "#ffffff", borderColor: "#f37c23", borderWidth: "1.5px" }
}
              className={`relative rounded-3xl p-7 border transition-all duration-300 hover:-translate-y-1 ${
                p.highlight
                  ? "text-white shadow-glow"
                  : "hover:shadow-soft"
              }`}
            >
              {p.highlight && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-ibh-orange to-amber-400 px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white shadow-soft">
                  <i className="fa-solid fa-bolt"></i>
                  Most Popular
                </span>
              )}

              {/* Header */}
              <p className={`text-xs uppercase tracking-[0.15em] font-semibold ${p.highlight ? "text-white/60" : "text-slate-500"}`}>
                {p.name}
              </p>
              <div className="mt-3 flex items-baseline gap-1">
                <span className={`font-display text-4xl font-bold ${p.highlight ? "text-white" : "text-slate-900"}`}>
                  {p.price}
                </span>
                <span className={`text-sm ${p.highlight ? "text-white/60" : "text-slate-500"}`}>{p.cycle}</span>
              </div>
              <p className={`mt-1 text-sm ${p.highlight ? "text-white/80" : "text-slate-600"}`}>{p.tagline}</p>
              <p className={`text-xs mt-0.5 ${p.highlight ? "text-white/50" : "text-slate-400"}`}>{p.subTagline}</p>

              {/* "Everything in" banner */}
              {p.everythingIn && (
                <div className="mt-5 flex items-center gap-2 text-sm font-semibold text-white/90">
                  <i className="fa-solid fa-circle-check text-emerald-300"></i>
                  {p.everythingIn}
                </div>
              )}

              {/* Feature sections */}
              <div className="mt-5 space-y-5">
                {p.sections.map((sec) => (
                  <div key={sec.label}>
                    <p className={`text-[10px] font-bold uppercase tracking-[0.15em] flex items-center gap-1.5 mb-2 ${p.highlight ? "text-white/80" : "text-slate-500"}`}>
                      <i className={`fa-solid ${sec.icon}`}></i>
                      {sec.label}
                    </p>
                    <ul className="space-y-1.5">
                      {sec.features.map((f) => (
                        <li
                          key={f}
                          className={`flex items-start gap-2.5 text-sm ${p.highlight ? "text-white/85" : "text-slate-700"}`}
                        >
                          <i className={`fa-solid fa-check mt-0.5 flex-shrink-0 ${p.highlight ? "text-emerald-300" : "text-emerald-500"}`}></i>
                          {f}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <a
              href={p.link || "#contact"}
  target={p.link ? "_blank" : "_self"}
  rel="noopener noreferrer"
  style={
    p.highlight
      ? { backgroundColor: "#ffffff", color: "#0d1117" }
      : { backgroundColor: "#00a000", color: "#ffffff" }
  }
  className={`mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all hover:opacity-90`}
  data-testid={`pricing-cta-${p.name}`}
  aria-label={`Get started with ${p.name}`}
>
  {p.cta} 
  <i className="fa-solid fa-arrow-up-right-from-square text-xs"></i>
</a>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-slate-500 mt-6">
          Both plans can be cancelled anytime.
        </p>
      </div>
    </section>
  );
};

export default Pricing;